module.exports = __webpack_public_path__ + "static/humanitas-logo.1dcf67fc.svg";